import {FC, useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {Panel, PanelGroup} from 'react-resizable-panels'
import {useLimpieza} from '../../../../../hooks/useLimpieza'
import {ResizeHandle} from '../../../../hoteleria/components/Layout/Container/ResizeHandle/ResizeHandle'
import ActionsContent from '../../componentes/Actions'
import ContainerWrapper from '../../componentes/Container'
import {renderPanelContent} from '../components'
import {yupResolver} from '@hookform/resolvers/yup'
import {typeBuildingSchema} from '../../../schema/typeBuilding'
import {TypeBuildingModel} from '../../../model/typeBuilding.model'
import {
  createModuleService,
  deleteModuleService,
  editModuleService,
} from '../../../../hoteleria/services/module.service'
import {TabLimpiezaModel} from '../../../../../models'
import {ShowSnackBar} from '../../../../../util/functions'
import {
  SUCCESS_MESSAGE_CREATE,
  SUCCESS_MESSAGE_DELETE,
  SUCCESS_MESSAGE_UPDATE,
} from '../../../../../util/Constants'
import Swal from 'sweetalert2'

const TypeBuildingPageWrapper: FC = () => {
  const {currentTabItem, changeCurrentTabItem} = useLimpieza()
  const [loading, setLoading] = useState(false)
  const methods = useForm<TypeBuildingModel>({
    resolver: yupResolver(typeBuildingSchema),
  })

  // console.log('currentTabItem in loadingtable: ', currentTabItem.loadingTable)

  const handleDelete = async () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Al eliminar no podrás revertir esta acción',
      //showDenyButton: true,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, eliminar',
      confirmButtonColor: 'var(--kt-primary)',
      //denyButtonText: `Don't save`,
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        setLoading(true)
        let id = [{Id: currentTabItem.idToDelete}]
        const data = await deleteModuleService(id)
        if (!data.data.error) {
          setLoading(false)

          const obj: TabLimpiezaModel = {
            ...currentTabItem,
            idToDelete: '',
            loadingTable: true,
          }
          changeCurrentTabItem(obj)
          ShowSnackBar(SUCCESS_MESSAGE_DELETE)
        } else {
          setLoading(false)
          changeCurrentTabItem({...currentTabItem, loadingTable: false})
          ShowSnackBar(data.data.message, 'error')
        }
        Swal.close()
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }

  const onSubmit = async (data: TypeBuildingModel) => {
    try {
      setLoading(true)
      const isCreating = !currentTabItem.idToEdit

      let num1 = data.Campoadicionalnum1 ? Number(data.Campoadicionalnum1) : 0
      data.Campoadicionalnum1 = num1
      let num2 = data.Campoadicionalnum2 ? Number(data.Campoadicionalnum2) : 0
      data.Campoadicionalnum2 = num2
      let num3 = data.Campoadicionalnum3 ? Number(data.Campoadicionalnum3) : 0
      data.Campoadicionalnum3 = num3
      let nroHabitaciones = data.NroHabitaciones ? Number(data.NroHabitaciones) : 0
      data.NroHabitaciones = nroHabitaciones
      let nroPisos = Number(data.NroPisos)
      data.NroPisos = nroPisos
      let prioridad = data.PrioridadAsignacion ? Number(data.PrioridadAsignacion) : 0
      data.PrioridadAsignacion = prioridad

      let message = isCreating ? SUCCESS_MESSAGE_CREATE : SUCCESS_MESSAGE_UPDATE

      if (currentTabItem.idToEdit) {
        // changeCurrentTabItem({...currentTabItem, loadingTable: true})
        const response = await editModuleService(data)
        if (!response.data.error) {
          setLoading(false)
          ShowSnackBar(message)
          const obj: TabLimpiezaModel = {
            ...currentTabItem,
            showPanel: false,
            idToEdit: '',
            content: {
              ...currentTabItem.content,
              detailPanel: '',
            },
            loadingTable: true,
            // updated: true,
          }
          changeCurrentTabItem(obj)
        } else {
          setLoading(false)
          ShowSnackBar(response.data.message, 'error')
          // setLoading(false)
          // changeCurrentTabItem({...currentTabItem, loadingTable: false, updated: false})
          // if (response.data.data && response.data.data.length > 0) {
          //   await setDataError(response.data.data)
          //   await setMessageError(response.data.message)
          //   await setShowModalError(true)
          // } else {
          //   getSnackBarToast(response.data.message, 'error')
          // }
        }
      } else {
        const response = await createModuleService(data)
        if (!response.data.error) {
          setLoading(false)
          ShowSnackBar(message)
          const obj: TabLimpiezaModel = {
            ...currentTabItem,
            showPanel: false,
            idToEdit: '',
            content: {
              headerPanel: 'table-type-of-building',
            },
            loadingTable: true,
          }
          changeCurrentTabItem(obj)
        } else {
          let message = response?.data?.message?.toString() || ''
          ShowSnackBar(message, 'error')
        }
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <ActionsContent
          deleteClick={handleDelete}
          loading={loading}
          textComponentBack='table-type-of-building'
          textComponentGo='form-type-of-building'
        />
        <ContainerWrapper>
          <PanelGroup autoSaveId='example' direction='vertical' style={{height: '100%'}}>
            <Panel
              collapsible={true}
              order={1}
              key={`panel-limpieza-header-${currentTabItem.id}`}
              id={`panel-limpieza-header-${currentTabItem.id}`}
              className={'panel__box'}
            >
              <>{renderPanelContent(currentTabItem.content.headerPanel)}</>
            </Panel>
            <>
              {currentTabItem.showPanel && (
                <>
                  <ResizeHandle />
                  <Panel
                    className={'panel__box'}
                    collapsible={true}
                    defaultSize={50}
                    order={2}
                    key={`panel-limpieza-detail-${currentTabItem.id}`}
                    id={`panel-limpieza-detail-${currentTabItem.id}`}
                  >
                    {renderPanelContent(currentTabItem.content.detailPanel)}
                  </Panel>
                </>
              )}
            </>
          </PanelGroup>
        </ContainerWrapper>
      </form>
    </FormProvider>
  )
}

export default TypeBuildingPageWrapper
